import React, { useState } from 'react'
import { Form, Col, Row, Button, Alert } from 'react-bootstrap'
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import Select from 'react-select'
import moment from 'moment'

import { formasPagamentoRadiologia } from '../../../constants/agendamento.constants'

export default function AgendamentoRadiologia(props) {
  const { clinicas, salvarAgendamento, nomePaciente, exameAnterior, utilizarExameAnterior } = props
  const [dataConsulta, setDataConsulta] = useState(new Date())
  const [selectedClinica, setSelectedClinica] = useState(null)
  const [selectedPagamento, setSelectedPagamento] = useState(null)

  const handleSalvar = () => {
    salvarAgendamento(dataConsulta, selectedClinica, selectedPagamento)
  }

  const opcoesClinica = (clinicas || []).map((c) => ({
    label: c.nome,
    value: c.id,
  }))

  return (
    <div className='px-4'>
      <h3 className='m-0 text-secondary font-weight-bold'>Agendamento Radiologia</h3>
      <div className='mt-5 mb-4'>
        Paciente: <h4>{nomePaciente}</h4>
      </div>
      {exameAnterior && (
        <Alert variant='info' className='d-flex justify-content-between align-items-center flex-wrap'>
          <div className='mr-3 mb-2 mb-md-0'>
            Esta paciente já possui exame radiológico concluído em{' '}
            <strong>{moment(exameAnterior.data).format('DD/MM/YYYY')}</strong>. É possível reaproveitar esse exame para
            efetivar o novo contrato, sem agendar outro.
          </div>
          <Button variant='outline-primary' onClick={utilizarExameAnterior}>
            Utilizar exame anterior
          </Button>
        </Alert>
      )}
      {opcoesClinica.length === 0 && (
        <Alert variant='warning'>Nenhuma clínica radiológica ativa cadastrada. Cadastre uma clínica para agendar um novo exame.</Alert>
      )}
      <Row>
        <Col md='4'>
          <Form.Group className='required'>
            <Form.Label htmlFor='dataRetorno'>Data da consulta</Form.Label>
            <MuiPickersUtilsProvider utils={MomentUtils} locale='pt-br'>
              <KeyboardDateTimePicker
                className='form-control'
                value={dataConsulta}
                onChange={setDataConsulta}
                variant='inline'
                format='DD/MM/YYYY HH:mm'
                required
                animateYearScrolling
                disablePast
              />
            </MuiPickersUtilsProvider>
          </Form.Group>
        </Col>
        <Col md='4'>
          <Form.Group className='required'>
            <Form.Label htmlFor='dataRetorno'>Clínica Radiológica</Form.Label>
            <Select
              options={opcoesClinica}
              placeholder=''
              value={selectedClinica}
              onChange={setSelectedClinica}
              noOptionsMessage={() => 'Nenhuma clínica cadastrada'}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className='d-flex align-items-center'>
        <Col md='4'>
          <Form.Group className='required'>
            <Form.Label htmlFor='dataRetorno'>Forma de Pagamento</Form.Label>
            <Select
              options={Object.values(formasPagamentoRadiologia)}
              placeholder=''
              value={selectedPagamento}
              onChange={setSelectedPagamento}
              noOptionsMessage={() => 'Nenhuma opção'}
            />
          </Form.Group>
        </Col>
        <Col className='align-items-center col-md-3 d-flex pt-3'>
          <Button variant='primary' onClick={handleSalvar} disabled={opcoesClinica.length === 0}>
            Salvar Agendamento
          </Button>
        </Col>
      </Row>
    </div>
  )
}
